export const INTEGRATION_NAME = 'mywallet';
export const NDS_CALC = 'nds-calc';
export const WALLET_CONFIG_KEY = 'CAIWalletConfig';
export const USER_SHOW_PAYMENTS_KEY = 'userShowPayments';
export const WALLET_BONNET = 'bonnet-webcomponent';
export const WALLET_GRID = 'wallet-grid';
export const WALLET_MODAL = 'wallet-modal';
export const WALLET_MANAGER = 'walletManagerBundle';
export const WALLET_TEXT_SEARCH = 'site-text-search';
export const LS_PENCIL_EVENT_KEY = 'cadrPencilTrackingEventData';
export const MMD_WIDGET_SELECTOR = '#mmd-widget';
export const MMD_TRACK_EVENT_NAME = 'PROFILE_UPDATED';
export const WS_INV_FILTERS = 'ws-inv-filters';
export const SHOW_PAYMENTS_NOTIFICATION = `${WS_INV_FILTERS}/show-payments-notification`;
export const WALLET_UPDATE_STATE = 'wallet-last-update';
export const WALLET_UPDATE_STATE_SOURCE = {
	AMD: 'AMD',
	WALLET: 'wallet'
};
export const UDS_SCRIPT_NAME = 'unified-deal-starter';
export const DDC_DEALER_DR_LEASE_ENABLED = 'ddc-dealer-dr-lease-enabled';
export const SECTIONS_VDP_PAGE_ID_PARTIAL = 'DETAIL_RESPONSIVE_SECTIONS_AUTO';
export const VDP_DR_SECTION_SELECTOR = '[data-name="vdp-price-purchase-wrapper-1"]';
export const INSTANT_EPRICE = 'instant-eprice';
export const INSTANT_EPRICE_SHOW_FOR_MYWALLET = 'instant-eprice.show-for-mywallet';

export const SDP_CLOSE_EVENTS = [
	'DR_SDP_CLOSE_OUTSIDE_CLICKED',
	'DR_SDP_CLOSE_X_CLICKED',
	'DR_SDP_LEAVE_BUTTON_CLICKED'
];

// these AMD events should not trigger a wallet update
export const AMD_UNUSED_EVENTS = [
	'DR_PAYMENT_DISPLAY',
	'DR_PAYMENT_TYPE_CHANGED',
	'DR_CONTINUE_TO_SDP_CLICKED',
	'DR_TRADEIN_OPENED',
	'DR_ZIP_CODE_UPDATED',
	'DR_NAVIGATE_TO_TERMS',
	'DR_PAYMENT_TERM_CHANGED',
	'DR_CREDIT_TIER_CHANGED',
];

export const TIMING_LABELS = {
	START_ESNTIAL_PROCESS: 'startEsntialPaymentProcess',
	END_ESNTIAL_PROCESS: 'endEsntialPaymentProcess',
	MEASURE_ESNTIAL_PROCESS: 'ESNTIAL_TOTAL_PAYMENT_TIME',
	START_ESNTIAL_UPDATE_PROCESS: 'startEsntialUpdatePaymentProcess',
	END_ESNTIAL_UPDATE_PROCESS: 'endEsntialUpdatePaymentProcess',
	MEASURE_ESNTIAL_UPDATE_PROCESS: 'ESNTIAL_TOTAL_PAYMENT_UPDATE_TIME',
	START_ESNTIAL_UDS_INT_LOAD: 'startEsntialUdsIntLoad',
	END_ESNTIAL_UDS_INT_LOAD: 'endEsntialUdsIntLoad',
	MEASURE_ESNTIAL_UDS_INT_LOAD: 'ESNTIAL_UDS_INT_LOAD_TIME',
	START_UDS_SCRIPT_LOAD: 'startUdsScriptLoad',
	END_UDS_SCRIPT_LOAD: 'endUdsScriptLoad',
	MEASURE_UDS_SCRIPT_LOAD: 'UDS_SCRIPT_LOAD_TIME',
};

// we use this if getting wallet from eventbus or local storage fails
export const WALLET_DEFAULT_OBJ = {
    creditAppDeals: [],
    creditType: null,
    isLoading: false,
    isPaymentsInfoLoaded: false,
    leaseMileageRange: null,
    leaseTerm: null,
    loanTerm: null,
    deals: [],
    dealDetails: {},
    dealNotifications: {},
    downPayment: null,
    downPaymentPercent: null,
    budget: null,
    dealType: null,
    interestRate: {},
    tradeIn: {
        value: null,
        amountOwed: null,
        condition: null,
        source: null,
        ico: []
    },
    monthlyBudget: null,
    icoTradeIn: {},
    lastUpdated: null,
    createdDate: null,
    hasPreviousPaymentInfo: false,
    paymentOption: 'finance',
    interactions: {
        disablePaymentPopover: false,
        disableComparePopover: false,
        disableBudgetCalculationAlert: false,
        useFallbackLead: false,
        hasOpenedTradeIn: false,
        hasOpenedWallet: false,
        hasUpdatedCreditOrTerm: false,
        hasUpdatedNDSCalc: false,
        hasUpdatedWallet: false,
        hasUpdatedPaymentOption: false,
        hasRequestedTaxesFees: false,
        hasBudgetInteraction: false,
        paymentEmphasis: false,
        hideReceipt: [],
        refreshReceipt: false
    },
    penciling: {
        customLender: {},
        offerPrice: null,
        icoTradeInOffer: null,
        pencilingPayments: {}
    },
    myWallet: {
        displayModal: false,
        hideBackButton: false,
        listingId: null,
        listingCategory: null,
        selectedPanelName: null,
        showPaymentDetailsModal: false,
        showPencilingPayments: false,
        displayWalletErrorMessage: false,
        configs: {}
    },
    creditVerification: {
        verified: false,
        verifiedDate: null
    },
    listingPayments: {},
    listingIncentives: {},
    listingLeasePayments: {},
    listingCashPayments: {},
    zip: null,
    timeStamp: null,
    previousPaymentInfo: {},
    walletId: null,
    hasSessionWalletChange: false
};
